<template>
    <e-button type="is-primary" icon-right="external-link-alt" @click.prevent="launch">
        <slot>Launch</slot>
    </e-button>
</template>

<script setup>
import LtiResourceLink from '@/models/LtiResourceLink.js';

const props = defineProps({ link: { type: LtiResourceLink, default: () => ({}) } });

const launch = () => window.open(`/lti/links/${props.link.id}`);
</script>
